import React from 'react';
import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { truncateWithEllipsis } from '../../../utils/truncateWithEllipsis';
import { sectorCardProp } from '../../../types';
import { PBSLink } from '../../atoms/link';

const SectorCard = ({ onClickProp, cardContent, index }) => {
	const { title, slug, intro, mainHeader, alt, buttonText } = cardContent;
	const { gatsbyImageData } = mainHeader.primaryImage;

	return (
		<article
			className={clsx(
				'flex flex-col group relative bg-white h-full w-full',
				'border-2 border-blue-200 border-solid rounded-sm shadow-card',
				'transition-shadow duration-300 motion-reduce:transition-none',
				'hover:shadow-default-hover focus-within:shadow-default-hover',
				'focus-within:outline focus-within:outline-offset-[-2px] focus-within:outline-2'
			)}
		>
			<GatsbyImage
				image={gatsbyImageData}
				alt={alt || title}
				className="aspect-[400/200]"
			/>

			<div className="flex flex-col grow">
				<div className="px-s-f">
					<h3 className="leading-tight py-s-f text-lg-f font-centra-medium">
						{title}
					</h3>
				</div>
				<div className="mb-8 px-s-f">
					<p className="text-sm md:text-base-f">
						{truncateWithEllipsis(intro, 120)}
					</p>
				</div>
				<PBSLink
					to={`${slug}`}
					variant="White"
					className="!text-s-f !font-centra-book !px-4 sm!py-3 !py-2 text-center leading-none mx-s-f mb-s-f mt-auto mr-auto"
					onClick={() =>
						onClickProp({
							component_name: 'category-card',
							click_type: 'button',
							click_title: title,
							click_text: `View all ${title.toLowerCase()}`,
							click_index: index + 1,
						})
					}
				>
					{buttonText}
				</PBSLink>
			</div>
		</article>
	);
};
SectorCard.defaultProps = {
	onClickProp: () => {},
};

SectorCard.propTypes = sectorCardProp;

export { SectorCard };
